import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DisplayCurrencyModule } from '@lib/util';
import { TotalBasket } from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/ui';

/**
 * Totals block (net, VAT per tax rate, gross) per currency. Shared by the editable basket step and the
 * read-only order summary so both steps always show the same amounts.
 */
@Component({
    selector: 'basket-currency-totals',
    templateUrl: './basket-currency-totals.component.html',
    styleUrls: ['./basket-currency-totals.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateModule, DisplayCurrencyModule],
})
export class BasketCurrencyTotalsComponent {
    readonly currencyTotals = input<TotalBasket[] | null>([]);

    /** VAT lines ascending by tax rate, as on the order; sorted copies keep the store state untouched. */
    protected readonly sortedCurrencyTotals = computed<TotalBasket[]>(() =>
        (this.currencyTotals() ?? []).map((currencyTotal) => ({
            ...currencyTotal,
            taxBreakdown: [...(currencyTotal.taxBreakdown ?? [])].sort((left, right) => left.taxRate - right.taxRate),
        })),
    );
}
